/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../../../styles/teams';

export const getTitleStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.black,
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.bold,
            height: '1.25rem',
            lineHeight: '1.25rem',
            padding: '0.125rem 2rem 0.125rem',
            marginBottom: '2rem',
        },
    };
};
